import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const bambooHr = defineConnector({
  identifier: "bambooHr",
  name: "BambooHR",
  tagLine: "HR management software",
  keywords:
    "bamboo hr hris human resources employee directory people ops time off",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://api\\.bamboohr\\.com/.*",
  auth: (app) =>
    basicAuth({
      username: app.secret.apiKey,
      password: "x",
    }),
  steps: [
    {
      title: "Get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Log in to your BambooHR account and navigate to your user account settings. Generate an API key from the API Keys section.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "Company subdomain",
          required: true,
          placeholder: "yourcompany",
          target: { kind: "configuration", field: "subdomain" },
          helperText:
            "Your BambooHR subdomain (e.g., yourcompany from yourcompany.bamboohr.com)",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ subdomain }) =>
      `https://api.bamboohr.com/api/gateway.php/${subdomain}/v1/employees/directory`,
  },
  publicEnvVars: ({ subdomain }) => ({
    BAMBOO_HR_SUBDOMAIN: subdomain || "",
  }),
});
